import { render, staticRenderFns } from "./siteStock.vue?vue&type=template&id=34beefbc&scoped=true"
import script from "./siteStock.vue?vue&type=script&lang=js"
export * from "./siteStock.vue?vue&type=script&lang=js"
import style0 from "./siteStock.vue?vue&type=style&index=0&id=34beefbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34beefbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34beefbc')) {
      api.createRecord('34beefbc', component.options)
    } else {
      api.reload('34beefbc', component.options)
    }
    module.hot.accept("./siteStock.vue?vue&type=template&id=34beefbc&scoped=true", function () {
      api.rerender('34beefbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/siteStock.vue"
export default component.exports